<script setup lang="ts">
import {computed} from "vue";

interface Props {
    items: Array<{ title: string; value: string }>
}

const props = defineProps<Props>();

const sortBy = defineModel<string>('sort-by');
const sortDir = defineModel<'desc' | 'asc'>('sort-dir');

const sortDesc = computed(() => sortDir.value === 'desc');

const switchSortDirection = () => {
    sortDir.value = sortDir.value === 'desc' ? 'asc' : 'desc';
};
</script>

<template>
    <v-select
        v-model="sortBy"
        :items="props.items"
        item-title="title"
        item-value="value"
        rounded="e-0"
        menu-icon="mdi-chevron-down"
        hide-details
    >
        <template #append>
            <v-tooltip
                location="bottom"
                content-class="bg-black border-sm text-tooltip"
                max-width="200"
            >
                <template #activator="{ props: bind }">
                    <v-icon-btn
                        v-bind="bind"
                        :icon="sortDesc ? 'mdi-sort-ascending' : 'mdi-sort-descending'"
                        tile
                        class="rounded custom-border rounded-s-0"
                        color="white"
                        @click="switchSortDirection"
                    />
                </template>
                Sort direction: {{ sortDesc ? 'Descending' : 'Ascending' }}
            </v-tooltip>
        </template>
    </v-select>
</template>

<style scoped>
:deep(.v-input__append) {
    margin-left: 0 !important;
}

.custom-border {
    border-bottom: 1px solid #8C8C8C;
    border-right: 1px solid #8C8C8C;
    border-top: 1px solid #8C8C8C;
}
</style>
